import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { applicationHistory } from '../../common/application-history';
import { toggleHeaderMenuExpanded } from '../../settings/actions/application-actions';
import { profileCustomerRequest } from '../../profile/actions/profile-actions';
import Button  from '../../common/components/button';
import '../style/navigation-menu.scss';
import UrlMappings from "../../common/url-mappings";

class HeaderMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shopExpanded: false,
			navigationExpanded: true
		};

		this.gotoShopUrl = this.gotoShopUrl.bind(this);
		this.gotoLocalUrl = this.gotoLocalUrl.bind(this);
		this.toggleShopMenuExpand = this.toggleShopMenuExpand.bind(this);
		this.toggleHeaderMenu = this.toggleHeaderMenu.bind(this);

		this.openLogoutContent = this.openLogoutContent.bind(this);
	}

	toggleShopMenuExpand(evt) {
		this.setState({ shopExpanded: !this.state.shopExpanded });
		evt.stopPropagation();
	}

	componentDidMount() {
		window.addEventListener('click', this.toggleHeaderMenu);
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.toggleHeaderMenu);
	}

	toggleHeaderMenu(evt) {
		const { headerMenuExpanded, toggleHeaderMenuExpanded } = this.props;
		if (headerMenuExpanded) {
			toggleHeaderMenuExpanded();
			evt.stopPropagation();
		}
	}

	gotoShopUrl(evt) {
		let suffix = '';
		if (evt.target.dataset.suffix) suffix = evt.target.dataset.suffix;
		else suffix = evt.target.parentElement.dataset.suffix;
		const newLocation = `${process.env.REACT_APP_SHOP_URI}${suffix}`;
		window.location = newLocation;
		evt.stopPropagation();
	}

	gotoLocalUrl(evt) {
		let loc = '';
		//HACK: This can be cleaner.
		let target = evt.target;
		while (!target.dataset && target.parentElement && target.dataset.length) target = target.parentElement;
		if (target.dataset.location) loc = target.dataset.location;
		else loc = target.parentElement.datset.location;
		this.toggleHeaderMenu(evt);
		if (loc.length > 0) applicationHistory.push(loc);
		evt.stopPropagation();
	}

	gotoHome() {
		applicationHistory.push('/my/albums');
	}

	openLogoutContent() {
		this.props.openLogoutDialog();
	}


	render() {
		const { headerMenuExpanded, customer } = this.props;

		return (
			<div role="menubar" className={`navigation-menu-container ${headerMenuExpanded ? '' : 'navigation-menu-closed'}`}>
				<div className={`navigation-menu`} role="menu">
					<div className="navigation-menu-item" onClick={this.gotoHome}>
						<div className="navigation-logo" />
					</div>
					<div className="navigation-menu-item dead-link hidden" role="menuitem" aria-labelledby="timeline">
						<div className="navigation-menu-item-icon timeline hidden" />
						<div className="navigation-menu-item-label hidden">Timeline</div>
					</div>
					{this.props.customer.acceptedTermsYn === "Y" && this.props.maintenanceMode !== true && <div>
					<div className="navigation-menu-item" data-location="/my/albums" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="albums" tabIndex="1">
						<div className="navigation-menu-item-icon album" data-location="/my/albums" />
						<div className="navigation-menu-item-label" data-location="/my/albums">
							Albums
						</div>
					</div>
					{this.props.maintenanceMode !== true &&
						<div className="navigation-menu-item" data-location="/my/discs" onClick={this.gotoLocalUrl}
							 role="menuitem" aria-labelledby="discs" tabIndex="2">
							<div className="navigation-menu-item-icon disc" data-location="/my/discs"/>
							<div className="navigation-menu-item-label" data-location="/my/discs">
								Discs
							</div>
						</div>
					}
					{!this.props.cart || this.props.cart.orderType !== "RPC" && this.props.maintenanceMode !== true &&
					<div className="navigation-menu-item" data-location="/my/usb-wizard" onClick={this.gotoLocalUrl}
						 role="menuitem" aria-labelledby="usb-wizard" tabIndex="2">
						<div className="navigation-menu-item-icon usb" data-location="/my/usb-wizard"/>
						<div className="navigation-menu-item-label" data-location="/my/usb-wizard">
							USB Drive
						</div>
					</div>
					}
						<hr className="splitter"/>
						{this.props.maintenanceMode !== true &&

						<div className="navigation-menu-item" data-location="/my/upload" onClick={this.gotoLocalUrl}
							 role="menuitem" aria-labelledby="upload" tabIndex="3">
							<div className="navigation-menu-item-icon upload" data-location="/my/upload"/>
							<div className="navigation-menu-item-label" data-location="/my/upload">
								Upload
							</div>
						</div>
						}
						{this.props.maintenanceMode !== true && this.props.downloadEnabled &&

						<div className="navigation-menu-item" data-location="/my/downloads" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="downloads" tabIndex="3">
							<div className="navigation-menu-item-icon download" data-location="/my/downloads" />
							<div className="navigation-menu-item-label" data-location="/my/downloads">
							Downloads
							</div>
							</div>
						}
					</div>} {/* acceptedTermsYn */}

					<hr className="splitter" />
					{/*<div*/}
						{/*className="navigation-menu-item"*/}
						{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true"*/}
						{/*onClick={this.gotoShopUrl}*/}
						{/*role="menuitem"*/}
                        {/*aria-labelledby="shop"*/}
                        {/*tabIndex="3">*/}
						{/*<div className="navigation-menu-item-icon shop" />*/}
						{/*<div className="navigation-menu-item-label">Shop</div>*/}
						{/*<div className={this.state.shopExpanded ? 'navigation-menu-caret caret-rotate' : 'navigation-menu-caret caret'} onClick={this.toggleShopMenuExpand}>*/}
							{/*&nbsp;*/}
						{/*</div>*/}
					{/*</div>*/}
					{/*<div role="menu">*/}
						{/*<div className={this.state.shopExpanded ? 'navigation-menu-item shop-submenu' : 'navigation-menu-item shop-submenu-hidden'}>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=prints"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="prints"*/}
                                {/*tabIndex="4">*/}
								{/*Prints*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=canvasprints"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="canvas prints and decor"*/}
                                {/*tabIndex="5">*/}
								{/*Canvas Prints & Decor*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=cards"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="cards"*/}
                                {/*tabIndex="6">*/}
								{/*Cards*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=photobooks"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="photo books"*/}
                                {/*tabIndex="7">*/}
								{/*Photo Books*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/store/ssoentrypoint?isLoggedIn=true&selection=null&product=gifts"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="photo gifts"*/}
                                {/*tabIndex="7">*/}
								{/*Photo Gifts*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=grad-announcements"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="grad announcements"*/}
                                {/*tabIndex="8">*/}
								{/*Grad Announcements*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=occasions"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="occasions"*/}
                                {/*tabIndex="9">*/}
								{/*Occasions*/}
							{/*</div>*/}
							{/*<div*/}
								{/*className="submenu-item"*/}
								{/*data-suffix="/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=deals"*/}
								{/*onClick={this.gotoShopUrl}*/}
								{/*role="menuitem"*/}
                                {/*aria-labelledby="deals"*/}
                                {/*tabIndex="10">*/}
								{/*Deals*/}
							{/*</div>*/}
						{/*</div>*/}
					{/*</div>*/}
					<div className="navigation-menu-item" data-location="/my/account/storage-plan" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="Storage Plan" tabIndex="11">
						<div className="navigation-menu-item-icon storage-plan" data-location="/my/account/storage-plan" />
						<div className="navigation-menu-item-label" data-location="/my/account/storage-plan" >Storage Plan</div>
					</div>

					<div className="navigation-menu-item" data-location="/my/cart" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="cart" tabIndex="12">
						<div className="navigation-menu-item-icon cart" data-location="/my/cart" />
						<div className="navigation-menu-item-label" data-location="/my/cart" >Cart &nbsp;<span>{ this.props.cart != null && this.props.cart.numCartItems > 0 ? " ("+(this.props.cart.numCartItems)+" Item" + (this.props.cart.numCartItems > 1?"s":"")+")":""}</span></div>
					</div>
					<div className="navigation-menu-item" data-location="/my/shop" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="Shop" tabIndex="13">
						<div className="navigation-menu-item-icon shop" data-location="/my/shop" />
						<div className="navigation-menu-item-label" data-location="/my/shop" >Shop</div>
					</div>
					{/*<div*/}
						{/*className="navigation-menu-item"*/}
						{/*data-suffix="/library/projects?isLoggedIn=true"*/}
						{/*onClick={this.gotoShopUrl}*/}
						{/*role="menuitem"*/}
                        {/*aria-labelledby="photo projects"*/}
                        {/*tabIndex="12">*/}
						{/*<div className="navigation-menu-item-icon photo-projects" />*/}
						{/*<div className="navigation-menu-item-label">Photo Projects</div>*/}
					{/*</div>*/}
					<hr className="splitter" />
					<div className="navigation-menu-item dead-link" data-location="/my/account" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="my account" tabIndex="14">
						<div className="navigation-menu-item-icon account" data-location="/my/account"/>
						<div className="navigation-menu-item-label" data-location="/my/account">My Account</div>
					</div>

					<a href="https://static.imemories.com/web-resources/v3/base/help/Content/Welcome_to_iMemories.htm" target="_blank" className="navigation-menu-item" aria-labelledby="help" tabIndex="15">
                        <div className="navigation-menu-item-icon help"/>
                        <div className="navigation-menu-item-label">Help</div>
					</a>

					{/*<div className="navigation-menu-item dead-link" data-location="/my/help" role="menuitem" aria-labelledby="help" tabIndex="14">*/}
						{/*<div className="navigation-menu-item-icon help" data-location="/my/help" />*/}
						{/*<div className="navigation-menu-item-label" data-location="/my/help">Help</div>*/}
					{/*</div>*/}
					{/*<div className="navigation-menu-item dead-link" data-location="/my/app-download" onClick={this.gotoLocalUrl} role="menuitem" aria-labelledby="app downloads" tabIndex="15">*/}
						{/*<div*/}
							{/*className="navigation-menu-item-icon app-download"*/}
							{/*data-location="/my/app-download"*/}
							{/*onClick={this.gotoLocalUrl}*/}
						{/*/>*/}
						{/*<div className="navigation-menu-item-label" data-location="/app-download">*/}
							{/*App Downloads*/}
						{/*</div>*/}
					{/*</div>*/}
					<div className="navigation-menu-item dead-link" aria-labelledby="Signed in as">
						<div className="navigation-signed-label">
							Signed in as:<br />
						</div>
					</div>
					<div className="navigation-menu-item dead-link">
						<div className="navigation-username-label">
							{customer ? customer.email : null}
							<br />
						</div>
					</div>

					<div className="navigation-menu-item" onClick={this.props.openLogoutDialog} tabIndex="16" style={{zIndex:9999999}}>
						<Button type="button" buttonStyle="secondary" className="signout-button" buttonLabel="Sign out" />
                        {/*<div className="signout-button" aria-labelledby="Sign out">Sign out</div>*/}
					</div>

					<div className="navigation-menu-item dead-link">
                        <a href="http://www.imemories.com/termsofservice" className="hamburger-link-left" target="_blank" rel="noopener noreferrer">Terms</a>
                        <a href="http://www.imemories.com/privacypolicy" className="hamburger-link-right" target="_blank" rel="noopener noreferrer">Privacy</a>
					</div>


				</div>
			</div>
		);
	}
}

HeaderMenu.propTypes = {
	toggleHeaderMenuExpanded: PropTypes.func,
	headerMenuExpanded: PropTypes.bool,
	customer: PropTypes.object,
	lastCustomerRequest: PropTypes.number,
	getCustomer: PropTypes.func,
	openLogoutDialog: PropTypes.func.isRequired,
	maintenanceMode: PropTypes.bool.isRequired,
	downloadEnabled: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
	return {
		headerMenuExpanded: state.applicationState.headerMenuExpanded,
		customer: state.profile.customer,
		lastCustomerRequest: state.profile.lastCustomerRequest,
		cart: state.cart,
		maintenanceMode: state.settings.systemProps["system.maintenance"] === true,
		downloadEnabled: state.cart.orderType !== "RPC" && (state.settings.attributes["web.download.allow"] == null || state.settings.attributes["web.download.allow"] !== "false")
	};
};

const mapDispatchToProps = dispatch => {
	return {
		toggleHeaderMenuExpanded: evt => {
			dispatch(toggleHeaderMenuExpanded());
			if (evt) evt.stopPropagation();
		},
		getCustomer: () => {
			dispatch(profileCustomerRequest(dispatch));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/header/components/header-menu.jsx